import React from "react";
import { Link } from "react-router-dom";
import { logUI } from "../../../api/andyliticsApi";
import { Icon, Typography } from '../../ecosystem';


const AppointmentPricing = (props) => {
    const { visit } = props;

    if (!window.store.getState().session.serverData.enablePricingTransparency) return <React.Fragment ></React.Fragment >;

    return visit === undefined || visit === null || visit.quoteAmount === ""
        ? <React.Fragment ></React.Fragment >
        : <div className="appt-pricing">
            <div className="appt-estimate"><Typography type="body-02" color="$color-secondary-a2">Estimate: </Typography></div>
            <div onClick={() => { logClick(visit); }} className="appt-tile__cost">
                <Typography bold type="heading-02"><Link className="amount" to={`/estimates/estimateDetails/${visit.csnIdOfAppointment}`}>{formatMoney(visit.quoteAmount)}</Link></Typography>  <Link to={`/estimates/estimateDetails/${visit.csnIdOfAppointment}`}></Link>
            </div>
        </div >;

};

const logClick = (visit) => {
    logUI("MBHWeb.UI.Dashboard.appointment.appointmentPricing", new Date(), window.location.href, visit, 'dashboard', 'link clicked');
}


const formatMoney = (amount) => {
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    return formatter.format(amount);
}

export default React.memo(AppointmentPricing);